import { createAction, handleActions } from 'redux-actions';

const setFilters = createAction("SCREENS/SUBBIES/SUBCONTRACTORS/SET_FILTERS");

const defaultState = {
  status: 'All',
  expiry: null,
  document: null,
  hasRightToWork: null,
  hourly_rate_min: null,
  hourly_rate_max: null,
  day_rate_min: null,
  day_rate_max: null,
};

const reducer = handleActions(
  {
    [setFilters]: (state, action) => Object.assign({}, state, action.payload)
  },
  defaultState
);

export { setFilters, reducer };
